<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Trekking Documents</h3>
        <div class="text-xs-right">
          <v-btn
              v-if="this.trekking_agency"
              @click="form=true"
              color="blue darken-3"
              dark
              fab
              x-small
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex sm12>
        <v-alert
            color="red"
            icon="mdi-file-alert"
            outlined
        >
          <template>
            Any changes in documents will lead agency to be unverified. Contact Department of Immigration for the
            verification after changes.
          </template>
        </v-alert>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex class="pb-0" xs4>
              <v-text-field
                  :elevation="0"
                  class="hidden-sm-and-down "
                  flat
                  hide-details
                  placeholder="Type something"
                  prepend-inner-icon="search"
                  solo
                  v-model="searchQuery"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
                :footer-props="footerProps"
                :headers="headers"
                :items="all"
                :loading="loading"
                :options.sync="pagination"
                :server-items-length="totalNumber"
                item-key="id"
            >
              <template v-slot:item.document="{ item }">
                <file-display
                    :src="item.document">
                </file-display>
              </template>
              <template v-slot:item.document_number="{ item }">
                {{ item.fiscalYear ? item.fiscalYear.name : item.document_number }}
              </template>

              <template v-slot:item.action="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="confirmDelete(item)"
                        class="ml-2"
                        color="red lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small>
                      <v-icon small>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                        @click="editDocument(item)"
                        class="ml-2"
                        color="primary lighten-1"
                        dark
                        dense
                        fab
                        v-on="on"
                        x-small>
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
        persistent
        transition="dialog-bottom-transition"
        v-model="form"
        width="700"
    >
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>{{ formData.id ? 'Edit' : 'New' }} Trekking Document</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!--                            <v-flex xs12>-->
              <!--                                <v-alert-->
              <!--                                        color="info"-->
              <!--                                        icon="mdi-alert-circle-outline"-->
              <!--                                        outlined>-->
              <!--                                    <template>Uploading of new file requires reverification of the account.-->
              <!--                                    </template>-->
              <!--                                </v-alert>-->
              <!--                            </v-flex>-->
              <v-flex v-if="errors" xs12>
                <v-alert
                    :key="key"
                    :value="true"
                    color="error"
                    icon="warning"
                    outlined
                    v-for="(value, key) in errors">
                  <template v-for="(item, index) in value">{{ item }}</template>
                </v-alert>
              </v-flex>
              <v-flex xs12>
                <v-form lazy-validation ref="formRef">
                  <v-card-text class="py-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                            :items="document_types"
                            :rules="[rules.required]"
                            class="pr-2"
                            item-text="name"
                            item-value="id"
                            label="Document Type"
                            outlined
                            v-model="formData.document_type">
                        </v-select>
                      </v-flex>
                      <v-flex v-if="formData.document_type !== 'tax_clearance_certificate'" xs6>
                        <v-text-field
                            :rules="[rules.required]"
                            class="pr-2"
                            label="Document Number *"
                            outlined
                            type="text"
                            v-model="formData.document_number"
                        ></v-text-field>
                      </v-flex>

                      <v-flex sm6
                              v-if="formData.document_type !== 'tax_clearance_certificate' &&  formData.document_type !== 'domestic_small_industries_license'">
                        <formatted-date
                            :label="(formData.document_type === 'company_registered_document' || formData.document_type === 'pan_vat_certificate') ? 'Registratioin Date ' : 'Expiry Date (B.S)'"
                            @blur="checkDate"
                            prepand_icon="event"
                            v-model="formData.validity"
                        ></formatted-date>

                      </v-flex>

                      <v-flex v-if="formData.document_type === 'tax_clearance_certificate'" xs6>
                        <v-select
                            :items="fiscalYears"
                            :rules="[rules.required]"
                            item-text="name"
                            item-value="id"
                            label="Fiscal year"
                            outlined
                            v-model="formData.fiscalYear"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex justify-center xs12>
                        <file-input
                            :rules=rules.required
                            label="File Attachment"
                            v-model="formData.document_file">
                        </file-input>
                      </v-flex>


                    </v-layout>
                  </v-card-text>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="form = false; formData={};$refs.formRef.reset();"
              class="white--text"
              color="red lighten-1"
          >Cancel
          </v-btn>
          <v-btn
              :loading="loading"
              @click="saveModel"
              class="white--text"
              color="blue darken-3"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import OutlinedDatePicker from "../components/OutlinedDatePicker";
import FormattedDate from "../components/FormattedDate";
import FileDisplay from "../components/FileDisplay";
import {validationMixin} from "../mixins/validationMixin";
import {CommonListMixin} from "../mixins/CommonListMixin";
import FileInput from "../components/FileInput";
import moment from 'moment';

import Http from 'axios';
import {API_URL, API_VERSION} from "../config/config";

export default {
  components: {FileInput, OutlinedDatePicker, FileDisplay, FormattedDate},
  data() {
    return {
      model: "trekking-documents",
      fiscalYears: [],
      document_types: [
        {
          id: 'company_registered_document',
          name: 'Company Registration Certificate'
        }, {
          id: 'pan_vat_certificate',
          name: 'PAN/VAT Certificate'
        }, {
          id: 'tourism_board_certificate',
          name: 'Tourism Board Certificate'
        }, {
          id: 'tourism_board_certificate',
          name: 'Tourism Board Certificate'
        }, {
          id: 'nepal_rastra_bank_license',
          name: 'Nepal Rastra Cank License'
        }, {
          id: 'tax_clearance_certificate',
          name: 'Tax Clearance Certificate'
        }, {
          id: 'domestic_small_industries_license',
          name: 'Domestic & Small Industries License'
        },
        {
          id: 'company_trekking_license',
          name: 'Trekking License Certificate'
        }
      ],
      rules: {
        required: value => !!value || "Required",
        afterToday: value => {
          let today_date = new Date().toISOString().substr(0, 10);
          return moment(value).isSameOrAfter(today_date) || "Date cannot be of past.";
        },
      },
      pagination: {
        itemsPerPage: 25,
        sortBy: ["created_at"],
        sortDesc: ["true"]
      }
    };
  },
  mixins: [validationMixin, CommonListMixin],
  computed: {
    ...mapGetters("AuthUser", ["trekking_agency"]),
    all() {
      return this.$store.state.CommonList.all;
    },
    headers() {
      let headers = [
        {
          text: 'S.N.',
          value: 's_no',
          sortable: false
        },
        {
          text: "Document Type",
          value: "document_type"
        },
        {
          text: "Document Number/ Fiscal Year",
          value: "document_number"
        },
        {
          text: "Document",
          value: "document"
        },
        {
          text: "Registration/Expiry Date",
          value: "validity"
        },
        {
          text: "Added On",
          value: "created_at"
        }
      ];

      headers.push(
          {
            text: "Action",
            value: "action"
          });
      return headers;
    }
  },
  methods: {

    saveModel() {
      if (this.$refs.formRef.validate()) {
        let formData = new FormData();
        formData.set("id", this.formData.id);
        formData.set("document_type", this.formData.document_type);
        if (this.formData.document_type === 'tax_clearance_certificate')
          formData.set("fiscal_year_id", this.formData.fiscalYear);
        else {
          formData.set("validity", this.formData.validity);
          formData.set("document_number", this.formData.document_number);
        }
        if (this.formData.document_file) {
          formData.set("document", this.formData.document_file);
        }
        this.modelData = formData;
        this.save('Trekking Document').then(() => {
        }).catch(e => this.errors = e.response.data.errors)
      }
    },
    editDocument(item) {
      this.formData = JSON.parse(JSON.stringify(item));
      this.formData.document_type = item.real_document_type;
      if (item.fiscalYear !== null)
        this.formData.fiscalYear = item.fiscalYear.id;
      this.form = true;
    },
    loadFiscalYears() {
      Http.get(API_URL + API_VERSION + "/fiscal-year/fetch-all")
          .then(response => {
            this.fiscalYears = response.data.data.sort((a, b) =>
                a.end_year > b.end_year ? 1 : -1
            ).map((item) => {
              return {
                id: item.id,
                name: item.start_year + '/' + item.end_year
              }
            });
          })
    },
    checkDate() {
      let date = this.formData.validity;
      date = date.split('-');
      let year = date[0];
      let month = date[1];
      let day = date[2];
      if (Number(month) > 12) {
        month = 12;
      }
      if (Number(day > 32)) {
        day = 32;
      }
      this.formData.validity = year + '-' + month + '-' + day;
    },
    async confirmDelete(item) {
      await this.destroy(item, 'Document deleted successfully');
    },
  },
  mounted() {
    this.$store.commit("CommonList/setModel", this.model);
    this.loadFiscalYears();
  }
};
</script>
